import { makeStyles } from "@material-ui/core";

export const useNoDataStyles = makeStyles(() => ({
    root: {
        margin: "100px 0px"
    }
}));
